import React from 'react';

import { MDText } from 'i18n-react';

import { WordpressData } from '../../@types/Wordpress';

import { GuideAuthorCard } from './GuideAuthorCard/GuideAuthorCard';
import LocalTexts from './GuideAuthorsContent.text.json';

import styles from './GuideAuthorsContent.module.scss';

export type AuthorContentProps = {
  data: WordpressData | null;
};

const LocalT = new MDText(LocalTexts);

export const GuideAuthorsContent: React.FC<AuthorContentProps> = ({ data }) => {
  const { guideAuthors, title } = data || {};

  return (
    <>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.description}>
        <p data-thc-style-override>{LocalT.translate('description')}</p>
        <p>{LocalT.translate('findOutMore')}</p>
      </div>
      {guideAuthors && guideAuthors.map((author) =>
        <GuideAuthorCard
          {...author} key={author.id}
        />)}
    </>
  );
};
